import type { RateRepository } from '@/core/rate'
import type { UseCase } from '@/core/shared'

export const deleteRate: UseCase<RateRepository, 'deleteRate'> = repository => {
  return async (payload) => {
    await repository.deleteRate(payload)
  }
}
